// @flow

import React from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { kpiSelectorMapping } from '../geminiConst';
import ChartFilterSelector from './ChartFilterSelector';
import { mappingKpiName } from '../../../../../const';

type Props = {
  selectedKpi: string,
  subKpiSelected: Object,
  setSelectedKpi: (string) => void,
  setSelectedSubKpi: (string, string) => void,
};

function ChartFilterMenu({
  selectedKpi, subKpiSelected, setSelectedKpi, setSelectedSubKpi,
}: Props) {
  return (
    <div className="kpi-selector">
      <div className="filter-header">
        <Translate value="GEMINI.KPI_FILTER" />
      </div>
      {
        Object.keys(kpiSelectorMapping)
          .map(kpi => (
            <ChartFilterSelector
              key={kpi}
              isSelected={selectedKpi === kpi}
              onClick={() => setSelectedKpi(kpi)}
              text={I18n.t(mappingKpiName[kpi])}
              selectedKpi={kpi}
              subKpiSelected={subKpiSelected[kpi]}
              setSubKpi={(subKpi: string) => setSelectedSubKpi(kpi, subKpi)}
            />
          ))
      }
    </div>
  );
}

export default ChartFilterMenu;
